const ru = {

    /* Language */
    "lang.ru": "RU",
    "lang.en": "EN",

    /* Menu */
    "menu.dashboard": "Dashboard",
    "menu.game": "Игры",
    "menu.player": "Игроки",
    "menu.studio": "Студии",
    "menu.bonus": "Бонус",
    "menu.message": "Сообщение",
    "menu.transaction": "Транзакции",
    "menu.booking": "Бронь VIP",
    "menu.currency": "Валюты",
    "menu.card": "Карты",
    "menu.dealer": "Дилера",
    "menu.managers": "Менеджеры",
    "menu.operators": "Операторы",
    "menu.rsg": "Отчёты RSG",
    "menu.log": "Логи",
    "menu.more": "Ещё",
    "menu.pitboard": "Pit Board",
    "pitboard.title": "Pit Board",
    "pitboard.subtitle": "Выберите студию и подтвердите переход",
    "pitboard.noStudios": "Нет доступных студий",
    "pitboard.go": "Перейти",
    "pitboard.close": "Закрыть",
    "pitboard.error": "Не удалось открыть Pit Board",

    /* Header */
    "header.profile": "Профиль",
    "header.changePassword": "Изменить пароль",
    "header.history": "История входа",
    "header.logout": "Выйти",
    "header.notifications": "Уведомления",
    "header.logoutTitle": "Выйти из панели?",
    "header.logoutText": "Чтобы вернуться, нужно будет снова ввести Email и пароль",

    /* Access roles */
    "access.superadmin": "Администратор",
    "access.manager": "Менеджер",
    "access.pitboss": "Питбос",
    "access.viewer": "Наблюдатель",

    /* Auth */
    "auth.title": "Панель управления",
    "auth.password": "Пароль",
    "auth.login": "Войти",
    "auth.error.emptyEmail": "Введите Email",
    "auth.error.invalidEmail": "Неверный формат Email",
    "auth.error.emptyPassword": "Введите пароль",
    "auth.error.shortPassword": "Пароль должен быть больше 8 символов",
    "auth.error.invalidCredentials": "Данные неверные!",
    "auth.error.userNotFound": "Пользователь не найден!",
    "auth.error.wrongPassword": "Неверный пароль!",
    "auth.error.tooManyAttempts": "Множество попыток входа! Попробуйте позднее.",
    "auth.error.generic": "Что-то пошло не так! Попробуйте позднее.",

    /* Layout (full-page states) */
    "layout.serverError": "Ошибка сервера!",
    "layout.serverErrorDesc": "Что-то пошло не так! Попробуйте позднее.",
    "layout.networkError": "Ошибка соединения!",
    "layout.networkErrorDesc": "Проверьте подключение к сети.",
    "layout.noAccess": "Нет доступа!",
    "layout.noAccessDesc": "У вас нет доступа для просмотра данных.",
    "layout.invalidKey": "Неверный ключ!",
    "layout.invalidKeyDesc": "Похоже ключ устарел! Перезагрузите страницу или войдите в свой аккаунт еще раз.",
    "layout.retry": "Повторить",
    "layout.reload": "Перезагрузить",
    "layout.empty": "Ничего не найдено!",
    "layout.emptyDesc": "Попробуйте еще раз изменив фильтры.",

    /* Notes */
    "notes.empty": "Нет заметок",
    "notes.title": "Заметки",
    "notes.createError": "Не удалось создать заметку!",
    "notes.placeholder": "Напишите текст",

    /* Dashboard notes modal */
    "dshNotes.title": "Все заметки",
    "dshNotes.subtitle": "Заметки по доступным вам играм",
    "dshNotes.games": "Игры",
    "dshNotes.allGames": "Все игры",
    "dshNotes.searchPlaceholder": "Поиск по тексту или автору",
    "dshNotes.empty": "Заметок пока нет",
    "dshNotes.nothingFound": "По этому фильтру заметок нет",
    "dshNotes.network": "Сеть недоступна, попробуйте позже",

    /* DateFilter */
    "filter.selectDate": "Выберите дату",
    "filter.selectDates": "Выберите даты",
    "filter.cancel": "Отменить",
    "filter.apply": "Применить",
    "filter.title": "Фильтр",
    "filter.subtitle": "Период и операторы списка игр",
    "filter.period": "Период",
    "filter.today": "Сегодня",
    "filter.week": "7 дней",
    "filter.month": "30 дней",
    "filter.reload": "Обновить список",
    "filter.operators": "Операторы",
    "filter.studios": "Студии",
    "filter.studiosSubtitle": "Показывать дилеров только выбранных студий",
    "filter.studiosEmpty": "Выберите хотя бы одну студию",
    "filter.selectAll": "Выбрать все",
    "filter.deselectAll": "Убрать все",

    /* Pagination */
    "pagination.showing": "Показано",
    "pagination.of": "из",

    /* Cards */
    "cards.empty": "Пусто",

    /* Transaction */
    "transaction.title": "Информация о транзакции",
    "transaction.number": "Номер транзакции",
    "transaction.player": "Игрок",
    "transaction.name": "Название",
    "transaction.type": "Тип",
    "transaction.time": "Время",
    "transaction.amount": "Сумма",
    "transaction.status": "Статус",
    "transaction.success": "Успешно",
    "transaction.error": "Ошибка",
    "transaction.result": "Результат",

    /* Time */
    "time.today": "Сегодня",
    "time.todayComma": "Сегодня, ",
    "time.yesterday": "Вчера",
    "time.yesterdayComma": "Вчера, ",
    "time.allTime": "За все время",

    /* Days of week */
    "days.monday": "Понедельник",
    "days.tuesday": "Вторник",
    "days.wednesday": "Среда",
    "days.thursday": "Четверг",
    "days.friday": "Пятница",
    "days.saturday": "Суббота",
    "days.sunday": "Воскресенье",

    /* Common */
    "common.add": "Добавить",
    "common.search": "Поиск",
    "common.back": "Назад",
    "common.delete": "Удалить",
    "common.edit": "Редактировать",
    "common.save": "Сохранить",
    "common.cancel": "Отмена",
    "common.close": "Закрыть",
    "common.yes": "Да",
    "common.no": "Нет",
    "common.name": "Название",
    "common.view": "Посмотреть",
    "common.enabled": "Включен",
    "common.disabled": "Отключен",
    "common.select": "Выбрать",
    "common.selectAll": "Выбрать все",
    "common.clearAll": "Отменить все",
    "common.generatePassword": "Сгенерировать пароль",
    "common.send": "Отправить",

    /* Common swal */
    "swal.deleteConfirm": "Вы действительно хотите удалить?",
    "swal.deleteWarning": "Невозможно восстановить после удаления",
    "swal.deleteButton": "Удалить!",
    "swal.cancelButton": "Отмена",
    "swal.noAccess": "Нет доступа!",
    "swal.invalidKey": "Неверный ключ!",
    "swal.generic": "Что-по пошло не так! <br /> Попробуйте позднее.",
    "swal.savedSuccess": "Данные успешно сохранены!",
    "swal.deleteGame": "Удалить игру?",
    "swal.deleteGameWarning": "После удаления восстановить невозможно.",
    "swal.cancelButton2": "Отменить",
    "swal.gameDeleted": "Игра удалена!",
    "swal.settingsSaved": "Данные успешно сохранены! <br /> Изменения появятся<br /> после обновления страницы.",

    /* Settings widget */
    "settings.tableName": "Название стола",
    "settings.tableKey": "Ключ стола",
    "settings.gameURL": "URL игры",
    "settings.serverURL": "URL сервера",
    "settings.type": "Тип",
    "settings.image": "Изображение",
    "settings.currentDealer": "Текущий Дилер",
    "settings.enterName": "Введите название стола",
    "settings.enterKey": "Введите ключ стола",
    "settings.enterGame": "Введите название игры",
    "settings.tokenCopied": "Токен успешно скопирован!",
    "settings.save": "Сохранить",
    "settings.mainSection": "Основное",
    "settings.linksSection": "Ссылки и подключение",
    "settings.designSection": "Оформление",
    "settings.tokensSection": "Токены",
    "settings.infoSection": "Информация",
    "settings.dangerSection": "Опасная зона",
    "settings.room": "Комната",
    "settings.backColor": "Цвет фона",
    "settings.pickColor": "Выбрать цвет",
    "settings.serviceURL": "URL сервиса студии",
    "settings.studio": "Студия",
    "settings.unknownGame": "Такого ключа нет в каталоге игр — страница игры не откроется",
    "settings.addImage": "Загрузить изображение",
    "settings.replaceImage": "Заменить изображение",
    "settings.copy": "Скопировать",
    "settings.parametersHint": "Видимость, доступ и график работы меняются во вкладке «Параметры»",
    "settings.gameNotSet": "Игра не выбрана",
    "settings.changeGame": "Изменить",
    "settings.pickGame": "Выбор игры",
    "settings.pickGameHint": "Ключ игры определяет страницу стола и логику раздачи",
    "settings.pickGameEmpty": "В этом типе нет доступных игр",
    "settings.pickGameChoose": "Выберите игру из каталога",
    "settings.deleteHint": "Стол удалится вместе со всеми своими данными, восстановить его будет нельзя",

    /* Dashboard */
    "dashboard.filterAll": "За все время",
    "dashboard.filterToday": "За сегодня",
    "dashboard.filterYesterday": "За вчера",
    "dashboard.filterWeek": "За неделю",
    "dashboard.filterMonth": "За месяц",
    "dashboard.filterYear": "За год",
    "dashboard.filterPeriod": "Период",
    "dashboard.title": "Dashboard",
    "dashboard.profit": "Прибыль (GGR)",
    "dashboard.visitors": "Посетители",
    "dashboard.players": "Игроки",
    "dashboard.rounds": "Раунды",
    "dashboard.games": "Игры",
    "dashboard.notes": "Заметки",
    "dashboard.activity": "Активность",
    "dashboard.transactions": "Транзакции",
    "dashboard.gamesReport": "Отчет по играм",
    "dashboard.reportGameName": "Название игры",
    "dashboard.reportPlayers": "Количество игроков",
    "dashboard.reportRounds": "Количество раундов",
    "dashboard.reportDebit": "Ставка (DEBIT)",
    "dashboard.reportCredit": "Выплата (CREDIT)",
    "dashboard.reportTotal": "Итого",
    "dashboard.reportSheet": "Отчет по играм",
    "dashboard.playersWord1": "игрок",
    "dashboard.playersWord24": "игрока",
    "dashboard.playersWord5": "игроков",

    /* Dashboard Breakdown — every operator by every studio */
    "dashboard.breakdownTitle": "Операторы и студии",
    "dashboard.breakdownNote": "Каждый оператор по каждой студии, все игры за выбранный период",
    "dashboard.breakdownReport": "Отчет по операторам и студиям (все игры)",
    "dashboard.breakdownEmpty": "За выбранный период данных по операторам нет",
    "dashboard.breakdownError": "Отчет не загрузился, нажмите чтобы повторить",
    "dashboard.breakdownOperator": "Оператор",
    "dashboard.breakdownStudio": "Студия",
    "dashboard.breakdownGame": "Игра",
    "dashboard.breakdownGamesCount": "Игр",
    "dashboard.breakdownStudiosWord": "студий",
    "dashboard.breakdownGamesWord": "игр",
    "dashboard.breakdownShowGames": "Показать игры",
    "dashboard.breakdownHideGames": "Скрыть игры",
    "dashboard.breakdownOperatorTotal": "Итого по оператору",
    "dashboard.breakdownUnknown": "Без названия",

    /* Dashboard Filter */
    "dsh.filterTitle": "Фильтр дашборда",
    "dsh.filterSubtitle": "Период, игроки, студии и операторы",
    "dsh.empty": "За выбранный период игр нет",
    "dsh.searchByStudio": "Поиск по студии",
    "dsh.studiosEmpty": "Доступных студий нет",
    "dsh.filterHint": "Пустой выбор означает все доступные студии и операторов. Показываются только те, к которым есть доступ.",

    /* Game pages */
    "game.title": "Игры",
    "game.add": "Добавить",
    "game.statistics": "Статистика",
    "game.messages": "Сообщения",
    "game.currencies": "Валюты",
    "game.settings": "Настройки",
    "game.parameters": "Параметры",
    "game.writeMessage": "Написать сообщение",
    "game.dealers": "Дилеры",
    "game.gameNumber": "Игра #",
    "game.connectionOk": "Соединение установлено",
    "game.connectionFail": "Соединение прервано",
    "game.connecting": "Соединение ...",
    "game.videoArchive": "Видео архив",
    "game.addTitle": "Новый стол",
    "game.tableName": "Название стола",
    "game.tableKey": "Ключ стола",
    "game.gameURL": "URL игры",
    "game.serverURL": "URL сервера",
    "game.tableStatuses": "Статусы стола:",
    "game.tableVisibility": "Видимость стола",
    "game.selectGame": "Выберите игру",
    "game.error.emptyName": "Введите название cтола",
    "game.error.emptyKey": "Введите ключ cтола",
    "game.error.invalidKey": "Недопустимое значение",
    "game.error.selectGame": "Выберите игру",
    "game.addedSuccess": "Игра успешно добавлена",
    "game.addSubtitle": "Три шага: игра, параметры стола и валюты",
    "game.typeSection": "Тип игры",
    "game.gameSection": "Игра",
    "game.tableSection": "Стол",
    "game.addType": "Новый тип",
    "game.typeName": "Название типа",
    "game.typeKey": "Ключ типа",
    "game.addCatalogGame": "Новая игра",
    "game.gameName": "Название игры",
    "game.gameKey": "Ключ игры",
    "game.gamePrefix": "Префикс таблиц",
    "game.catalogHint": "Ключ игры — это сегмент адреса стола и значение колонки Tables.game, префикс — начало имён таблиц игры",
    "game.emptyType": "В этом типе пока нет игр",
    "game.emptyList": "Столы не найдены",
    "game.error.duplicate": "Такой ключ уже занят",
    "game.error.emptyTypeName": "Введите название типа",
    "game.error.invalidTypeKey": "Ключ типа: латиница в нижнем регистре, цифры и дефис",
    "game.error.emptyGameName": "Введите название игры",
    "game.error.invalidGameKey": "Ключ игры: латиница в нижнем регистре, цифры и дефис",
    "game.error.selectType": "Выберите тип игры",
    "game.stepGame": "Игра",
    "game.stepGameHint": "Тип и игра каталога",
    "game.stepTable": "Стол",
    "game.stepTableHint": "Название, ключ, студия",
    "game.stepCurrency": "Валюты",
    "game.stepCurrencyHint": "Лимиты и фишки",
    "game.addressSection": "Адреса и режим",
    "game.selectAllCurrencies": "Выбрать все",
    "game.clearCurrencies": "Убрать все",
    "game.currencySection": "Валюты",
    "game.studio": "Студия",
    "game.noStudio": "Не выбрана",
    "game.studioLive": "Живая игра всегда ведётся в студии",
    "game.studioOptional": "Для электронной игры студия необязательна",
    "game.keyHint": "Латиница в нижнем регистре, цифры и дефис",
    "game.roomHint": "Комната трансляции, если стол её использует",
    "game.rtpHint": "Процент возврата электронной игры",
    "game.visibilityHint": "Отключённый стол не показывается игрокам",
    "game.min": "Минимальная ставка",
    "game.max": "Максимальная ставка",
    "game.maxPay": "Максимальная выплата",
    "game.chips": "Номиналы фишек",
    "game.chipsHint": "Через запятую, номинал-#цвет. Значения подставлены по курсу фишки валюты",
    "game.emptyCurrency": "Выберите валюты стола выше",
    "game.currencyHint": "Валюты можно добавить и позже, в настройках стола",
    "game.catalogTitle": "Каталог",
    "game.catalogSubtitle": "Типы игр и игры, из которых создаются столы",
    "game.tabTypes": "Типы",
    "game.tabGames": "Игры",
    "game.allTypes": "Все типы",
    "game.gamesCount": "игр",
    "game.editType": "Редактировать тип",
    "game.editCatalogGame": "Редактировать игру",
    "game.liveType": "Живая игра",
    "game.liveHint": "Столы такого типа ведутся дилером в студии",
    "game.gameColor": "Цвет карточки",
    "game.gameVisibility": "Доступна при создании",
    "game.gameVisibilityHint": "Скрытая игра не показывается в списке выбора",
    "game.keyLocked": "Ключ нельзя изменить — он используется в адресах и в базе",
    "game.gameKeyHint": "Сегмент адреса стола и значение колонки Tables.game",
    "game.prefixHint": "Начало имён таблиц игры, например RMP",
    "game.error.selectStudio": "Выберите студию",
    "common.next": "Далее",

    /* Electron game widget - games list */
    "widget.searchByNumber": "Поиск по номеру игры",
    "widget.playerID": "ID игрока",
    "widget.to": "до",
    "widget.gameNumber": "Номер игры",
    "widget.dealer": "Дилер",
    "widget.players": "Игроки",
    "widget.status": "Статус",
    "widget.date": "Дата",
    "widget.saved": "Сохранённые",
    "widget.operator": "Оператор",
    "widget.winNumber": "Выигрышный номер",
    "widget.winner": "Победитель",
    "widget.problemHint": "Отмеченные раунды содержат транзакции, которые не прошли — откройте раунд и проверьте",
    "widget.totalWin": "Выигрыш",
    "widget.bets": "Ставки",
    "widget.noWin": "Без выигрыша",
    "widget.paused": "На паузе",
    "widget.completed": "Завершен",
    "widget.notCompleted": "Не завершен",

    /* Game info widget */
    "widget.finishConfirm": "Вы действительно хотите завершить игру?",
    "widget.finishWarning": "Невозможно восстановить после изменений",
    "widget.finishButton": "Да, завершить",
    "widget.finishSuccess": "Игра завершена успешно!",
    "widget.finishDone": "Завершение выполнено!",
    "widget.alreadyFinished": "Игра уже завершена!",
    "widget.unknownError": "Неизвестная ошибка! Пожалуйста, повторите попытку позже.",
    "widget.gamePaused": "Игра на паузе!",
    "widget.finishConfirmAlt": "Вы действительно завершить игру?",
    "widget.finishWarningAlt": "Невозможно восстановить после завершения",

    /* VipGame game info */
    "widget.game": "Игра",
    "widget.gameStatus": "Статус игры",
    "widget.pauseStatus": "Статус паузы",
    "widget.changeStatus": "Статус изменении",
    "widget.changed": "Изменен",
    "widget.player": "Игрок",
    "widget.total": "Итого",
    "widget.balanceBefore": "Баланс до игры",
    "widget.balanceAfter": "Баланс после игры",
    "widget.finishGame": "Завершить игру",
    "widget.finishAndRefund": "Завершить и вернуть ставку",
    "widget.pauseGame": "Приостановить игру",
    "widget.resetCards": "Сбросить карты",
    "widget.continueWithout": "Продолжить без изменении",
    "widget.pauseConfirm": "Вы действительно хотите сделать паузу?",
    "widget.pauseWarning": "Игра будет приостановлена",
    "widget.pauseButton": "Да, приостановить",
    "widget.alreadyPaused": "Игра уже на паузе!",
    "widget.gameFinished": "Игра завершена!",
    "widget.warningStatusDb": "Внимание! Статус изменен только<br /> в базе данных, так как<br /> эта не текущая игра!",
    "widget.finishTxError": "Игра завершена! Не удалось завершить транзакцию!",

    /* Refund */
    "widget.refundTitle": "Возврат ставки",
    "widget.payTitle": "Оплата суммы",
    "widget.totalBet": "Общая ставка",
    "widget.refunded": "Возвращено",
    "widget.paid": "Оплачено",
    "widget.enterAmount": "Введите сумму",
    "widget.pay": "Оплатить",
    "widget.amountError": "Введите сумму",
    "widget.refundSuccess": "Возврат успешно завершен",
    "widget.paySuccess": "Оплата успешно завершена",
    "widget.refundTitle2": "Возврат средств: ",
    "widget.payTitle2": "Пополнение суммы: ",
    "widget.balance": "Баланс",
    "widget.playerInfo": "Информация о игроке",
    "widget.rouletteNumber": "Номер",
    "widget.rouletteBet": "Ставка",
    "widget.rouletteWin": "Выигрыш",
    "widget.somethingWrong": "Что-то пошло не так! Попробуйте позднее!",

    /* Statistics widget */
    "stats.players": "Количество Игроков",
    "stats.anteBets": "Количество ставок ANTE",
    "stats.totalTime": "Общее время",
    "stats.profit": "ПРИБЫЛЬ:",
    "stats.avgAnte": "Средняя ставка ANTE",
    "stats.combinations": "Комбинации",
    "stats.period": "Статистика за период",
    "stats.day": "День",
    "stats.week": "Неделя",
    "stats.month": "Месяц",
    "stats.statsFor": "Статистика за",
    "stats.testerWarning": "Внимание! Статистика не включает данные тестировщиков!",
    "widget.from": "с",

    /* Table Control widget */
    "control.bridgeConnected": "Подключено к Bridge",
    "control.bridgeError": "Ошибка Bridge",
    "control.noGameConnection": "Нет подключение с игрой!",
    "control.enterTime": "Введите время",
    "control.tableVisibility": "Видимость стола",
    "control.makePublicHidden": "Сделайте стол публичным или скрытым",
    "control.tableFree": "Стол свободен",
    "control.tableBusy": "Стол занят",
    "control.autoDetect": "Определяется автоматически",
    "control.tableAccess": "Доступ к столу (открыть/закрыть смену)",
    "control.allowDeny": "Разрешить или запретить вход на стол",
    "control.tableClosed": "Cтол закрыт",
    "control.tableOpen": "Cтол работает",
    "control.allDay": "Круглосуточно",
    "control.allDayWork": "Круглосуточная работа",
    "control.workStart": "Время начала работы",
    "control.workEnd": "Время окончания работы",
    "control.stateSection": "Состояние стола",
    "control.timeSection": "График работы",

    /* Table panels */
    "panel.controlHint": "Видимость, доступ и график работы стола",
    "panel.messageHint": "Сообщения игроков за столом",
    "panel.dealerHint": "Дилеры, допущенные к столу",
    "panel.currencyHint": "Валюты и лимиты ставок",
    "panel.settingsHint": "Параметры и подключение стола",
    "panel.statisticsHint": "Показатели игры за период",

    /* Table Refunds widget */
    "refund.transactionNumber": "Номер транзакции",
    "refund.name": "Название",
    "refund.amount": "Сумма",
    "refund.amountUSD": "Сумма (USD)",
    "refund.admin": "Админ",
    "refund.dateTime": "Дата и время",
    "refund.success": "Успешно",
    "refund.error": "Ошибка",
    "refund.title": "Возвраты",

    /* Round card — the same one in every game */
    "refund.subtitle": "Транзакции раунда и кто выполнил возврат",
    "refund.player": "Игрок",
    "refund.refunded": "Возвратов",
    "refund.refundedTotal": "Возвращено",
    "refund.onlyRefunds": "Только возвраты",
    "refund.everything": "Все транзакции",
    "refund.byPlayer": "Игра",
    "refund.unknownAdmin": "Админ не записан",
    "refund.emptyRefunds": "Возвратов не было",
    "refund.emptyRefundsDesc": "В этом раунде админы не возвращали деньги. Откройте все транзакции, чтобы увидеть ставки и выплаты.",
    "round.about": "О раунде",
    "round.money": "Деньги раунда",
    "round.actions": "Действия",
    "round.gameActions": "Действия с игрой",
    "round.pauseActions": "Пауза",
    "round.paymentActions": "Платежи",
    "round.cards": "Карты раунда",
    "round.players": "Игроки",
    "round.bets": "Ставки",
    "round.betsTotal": "Сумма ставок",
    "round.balance": "Баланс до и после",
    "round.balanceEmpty": "Оператор не записал баланс по этому раунду",
    "round.wallet": "Кошелёк",
    "round.problem": "Проблема",
    "round.noRoundId": "Возвраты недоступны: у раунда нет roundId",
    "round.loading": "Загрузка…",
    "round.playerSubtitle": "Игрок в этом раунде",
    "round.dealerCards": "Карты дилера",
    "round.playerCards": "Карты игрока",
    "round.additionalCards": "Дополнительные карты",
    "round.buyCards": "Карта покупки",
    "round.bankerCards": "Карты банкира",
    "round.positionCard": "Карта раздачи",
    "round.burnedCards": "Сожжённые карты",
    "round.box": "BOX",
    "round.cardsHidden": "Карты скрыты: раунд не завершён и не на паузе",

    /* VipGame/MultiGame specific */
    "widget.finishConfirmBtn": "Завершить",
    "widget.gamePausedSuccess": "Игра на паузе",
    "widget.gameNotPaused": "Игра не на паузе!",
    "widget.continueConfirm": "Вы действительно хотите продолжить?",
    "widget.continueText": "Игра будет продолжаться без изменении",
    "widget.gameContinued": "Игра продолжается",
    "widget.resetCardsText": "Карты будут сброшены",
    "widget.cardsReset": "Карты сброшены",
    "widget.refundAllConfirm": "Вы действительно хотите возвращать ставку всем?",
    "widget.refundAllWarning": "Операцию отменить нельзя",
    "widget.refundAllBtn": "Да, возвращать",
    "widget.refundsComplete": "Возвраты выполнены!",
    "widget.searchByPlayerNumber": "Поиск по номеру игрока",
    "widget.gameNumber2": "Номер игры",
    "widget.roundId": "ID раунда",
    "widget.empty": "Пусто",
    "widget.playersCount": "Количество игроков",
    "widget.transactionCount": "Количество транзакции",
    "widget.allRefunds": "Все возвраты",
    "widget.refundAllBets": "Вернуть ставку всем",
    "widget.refundAllBetsAndPay": "Вернуть все ставки и оплаты",
    "widget.continueGame": "Продолжить игру",
    "widget.refundAndPayAllConfirm": "Вы действительно хотите возвращать ставку и оплату всем?",
    "widget.allRefundsComplete": "Все возвраты выполнены!",
    "widget.operationConfirm": "Вы действительно хотите выполнить операцию?",

    /* Studio Room */
    "studio.participantsTitle": "Участники",
    "studio.nameLabel2": "Имя",
    "studio.disconnectStream": "Отключить стрим",

    /* Bonus Jackpot Connect/Update */
    "bonus.selectOperator": "Выберите оператора",
    "bonus.cashLabel": "Касса, $",
    "bonus.visibility": "Видимость",
    "bonus.connect2": "Соединить",
    "bonus.connectJackpotTitle": "Подключить JACKPOT",
    "bonus.send": "Отправить",


    /* Player widget */
    "player.information": "Общая\u0020информация",
    "player.sessions": "Сессии",
    "player.filter": "Фильтр",
    "player.operators": "Операторы",
    "player.selectOperator": "Выберите минимум 1 оператора",
    "player.selectDates": "Выберите даты",
    "player.last3h": "Последних 3 часа",
    "player.last6h": "Последних 6 часов",
    "player.last12h": "Последних 12 часов",
    "player.today": "Сегодня",
    "player.yesterday": "Вчера",
    "player.last7days": "Последних 7 дней",
    "player.last14days": "Последних 14 дней",
    "player.last30days": "Последних 30 дней",
    "player.thisMonth": "Этот месяц",
    "player.prevMonth": "Предыдущий месяц",
    "player.allTime": "За все время",
    "player.tester": "Тестировщик",
    "player.player": "Игрок",
    "player.operator": "Оператор",
    "player.rounds": "Количество раундов",
    "player.avgBet": "Средняя ставка",
    "player.totalTime": "Общее время",
    "player.selectPeriod": "Выберите период",
    "player.statsAll": "За\u00A0все\u00A0время",
    "player.statsDay": "День",
    "player.statsWeek": "Неделя",
    "player.statsMonth": "Месяц",
    "player.statsPeriod": "Период",
    "player.roundCount": "Количество раундов",
    "player.report": "Отчет по игрокам",
    "player.reportName": "Имя игрока",
    "player.reportCode": "Код игрока",
    "player.reportLastGame": "Последняя игра",
    "player.reportOperator": "Оператор",
    "player.reportCurrency": "Валюта",
    "player.reportLastSession": "Последняя сессия",
    "player.reportTester": "Тестировщик",
    "player.reportVip": "VIP",
    "player.reportTesterYes": "Да",
    "player.reportTesterNo": "Нет",
    "player.reportSheet": "Отчет по игрокам",
    "player.title": "Игроки",
    "player.lastGame": "Последняя игра",
    "player.currency": "Валюта",
    "player.balance": "Баланс",
    "player.dateTime": "Дата и время",
    "player.statsTitle": "Статистика игрока",
    "player.isTester": "Тестировщик",
    "player.isVip": "VIP",
    "player.viewStats": "Посмотреть статистику",
    "player.setTester": "Отметить как тестировщика",
    "player.removeTester": "Убрать статус тестировщика",
    "player.setVip": "Включить VIP статус",
    "player.removeVip": "Отключить VIP статус",
    "player.setBlocked": "Заблокировать",
    "player.removeBlocked": "Разблокировать",
    "player.blocked": "Заблокирован",
    "player.search": "Поиск по имени и коду",
    "player.hideTesters": "Убрать тестировщиков",
    "player.filterPeriod": "Период",
    "player.changeConfirm": "Вы действительно хотите поменять?",
    "player.changeWarning": "Эта влияет на статистику",
    "player.changeVipWarning": "Эта влияет на VIP статус игрока",
    "player.changeBlockWarning": "Заблокированный игрок не сможет войти ни в одну игру",
    "player.changeUnblockWarning": "Игрок снова сможет входить в игры",
    "player.statusChanged": "Статус успешно изменен",
    "player.sessionSid": "SID сессии",
    "player.sessionLastGame": "Последняя игра",
    "player.sessionGames": "Игр",
    "player.sessionRounds": "Раунды",
    "player.sessionTransactions": "Транзакции",
    "player.sessionEntered": "Вход",
    "player.sessionLastTx": "Последняя транзакция",
    "player.sessionsEmpty": "Сессии не найдены",
    "player.roundsTab": "Раунды",
    "player.roundsTotal": "Всего раундов",
    "player.roundTxs": "Транзакций",
    "player.roundsEmpty": "Раунды не найдены",

    /* Players section */
    "plr.empty": "Игроки не найдены",
    "plr.noGame": "Игра удалена",
    "plr.activity": "Активность",
    "plr.more": "Ещё",
    "plr.playersCount": "Игроков",
    "plr.testersCount": "Тестировщиков",
    "plr.sessionsCount": "Сессий",
    "plr.roundsCount": "Раундов",
    "plr.debitNote": "Ставки игроков",
    "plr.creditNote": "Выплаты игрокам",
    "plr.copyCode": "Скопировать код игрока",
    "plr.codeCopied": "Код игрока скопирован",
    "plr.filterTitle": "Фильтр игроков",
    "plr.filterSubtitle": "Период, сортировка, операторы и игры",
    "plr.filterHint": "Пустой выбор означает все доступные игры вашего доступа",
    "plr.searchByOperator": "Поиск по оператору",
    "plr.sort": "Сортировка",
    "plr.sortDate": "По последней активности",
    "plr.sortGgr": "GGR по убыванию",
    "plr.sortGgrAsc": "GGR по возрастанию",
    "plr.sortDebit": "По ставкам",
    "plr.sortRounds": "По раундам",
    "plr.sortName": "По имени",
    "plr.totalTitle": "Итого",
    "plr.watchButton": "Контроль входа",
    "plr.watchTitle": "Контроль входа игроков",
    "plr.watchSubtitle": "При запуске любой игры отмеченным игроком в телеграм придёт уведомление",
    "plr.watchPlayer": "ID игрока",
    "plr.watchOperator": "Оператор",
    "plr.watchAdd": "Добавить",
    "plr.watchEmpty": "Список пуст — добавьте игрока, чтобы получать уведомления о его входе",
    "plr.watchEnterPlayer": "Введите ID игрока",
    "plr.watchSelectOperator": "Выберите оператора",
    "plr.watchExists": "Этот игрок уже в списке",
    "plr.watchAdded": "Игрок добавлен в контроль входа",
    "plr.watchRemoved": "Игрок убран из контроля входа",
    "plr.watchLastLogin": "последний вход",
    "plr.watchNeverEntered": "ещё не заходил",
    "plr.notifyOff": "Уведомлять при входе",
    "plr.notifyOn": "Уведомления включены",
    "plr.notifyEnabled": "Уведомления о входе включены",
    "plr.notifyDisabled": "Уведомления о входе отключены",
    "plr.roundsShort": "Раунды",
    "plr.betShort": "Ср. ставка",
    "plr.timeShort": "Время в игре",
    "plr.periodStats": "Статистика по периоду",
    "plr.gamesNote": "за все время",
    "plr.games": "Игры",
    "plr.gamesShort": "игр",
    "plr.gamesEmpty": "У игрока пока нет сыгранных игр",
    "plr.pickerSubtitle": "Выберите начало и конец периода",
    "plr.sessionsHint": "Нажмите на сессию, чтобы открыть её раунды",
    "plr.sidCopied": "Код сессии скопирован",
    "plr.copySid": "Скопировать код сессии",
    "plr.openRounds": "Открыть раунды сессии",
    "plr.clearSession": "Показать все раунды",
    "plr.clearGame": "Убрать фильтр по игре",
    "plr.openGameRounds": "Открыть раунды игры",
    "plr.gamesHint": "Нажмите на игру, чтобы открыть её раунды",
    "plr.copyRound": "Скопировать номер раунда",
    "plr.roundCopied": "Номер раунда скопирован",
    "plr.txEmpty": "Транзакции раунда не найдены",

    /* Manager pages */
    "manager.title": "Менеджеры",
    "manager.createTitle": "Создать администратора",
    "manager.createSubtitle": "Выберите роль и назначьте доступ",
    "manager.editTitle": "Редактировать администратора",
    "manager.editSubtitle": "Роль и доступ можно изменить в любой момент",
    "manager.historyTitle": "История входа",
    "manager.activityTitle": "Активность",
    "manager.name": "Имя",
    "manager.role": "Роль",
    "manager.scope": "Доступ",
    "manager.scopeGlobal": "Все студии и операторы",
    "manager.scopeGlobalHint": "Менеджер видит все студии и всех операторов",
    "manager.scopeEmpty": "Доступ не назначен",
    "manager.studios": "Студии",
    "manager.operators": "Операторы",
    "manager.selectRole": "Выберите роль",
    "manager.selectStudio": "Выберите студию",
    "manager.activity": "Активность",
    "manager.history": "История входа",
    "manager.edit": "Редактировать",
    "manager.changePassword": "Изменить пароль",
    "manager.delete": "Удалить",
    "manager.newPassword": "Новый пароль",
    "manager.repeatNewPassword": "Повторите новый пароль",
    "manager.addedSuccess": "Администратор успешно добавлен",
    "manager.savedSuccess": "Администратор успешно сохранен",
    "manager.deletedSuccess": "Администратор успешно удален",
    "manager.passwordSaved": "Пароль успешно сохранен",
    "manager.device": "Устройство",
    "manager.browser": "Браузер",
    "manager.ip": "IP адрес",
    "manager.country": "Страна, Город",
    "manager.lastActivity": "Последняя активность",
    "manager.game": "Игра",
    "manager.action": "Действие",
    "manager.dateTime": "Дата и время",
    "manager.general": "Общий",
    "manager.roleText.manager": "Все студии и операторы, кроме настроек суперадмина",
    "manager.roleText.pitboss": "Управляет одной своей студией",
    "manager.roleText.viewer": "Только просмотр по выбранным операторам",
    "manager.selectRoleHint": "Сначала выберите роль — от неё зависит, какой доступ нужно назначить",
    "manager.pitbossHint": "Питбос управляет столами и дилерами только своей студии",
    "manager.viewerHint": "Наблюдатель видит столы выбранных операторов внутри выбранных студий — без права изменять",
    "manager.nothingAvailable": "Нет доступных значений",
    "manager.passwordHint": "После смены пароля администратору придётся войти заново",
    "manager.superadminLocked": "Изменение недоступно",
    "manager.you": "Вы",
    "manager.empty": "Администраторов пока нет",
    "manager.noHistory": "Входов пока не было",
    "manager.noActivity": "Активности пока не было",
    "manager.error.emptyName": "Введите имя",
    "manager.error.emptyEmail": "Введите Email",
    "manager.error.invalidEmail": "Неверный формат Email",
    "manager.error.emptyPassword": "Введите пароль",
    "manager.error.shortPassword": "Пароль должен быть больше 8 символов",
    "manager.error.selectRole": "Выберите роль",
    "manager.error.oneStudio": "Питбосу нужно выбрать одну студию",
    "manager.error.emptyStudios": "Выберите хотя бы одну студию",
    "manager.error.emptyOperators": "Выберите хотя бы одного оператора",

    /* Profile panels */
    "profile.title": "Профиль",
    "profile.subtitle": "Данные аккаунта и доступы",
    "profile.data": "Данные",
    "profile.access": "Доступ",
    "profile.currentSession": "Текущая сессия",
    "profile.uploadImage": "Загрузить изображение",
    "profile.removeImage": "Удалить изображение",
    "profile.removeImageTitle": "Удалить изображение?",
    "profile.removeImageText": "Вместо изображения будут показаны первые буквы имени",
    "profile.stats.games": "Игры",
    "profile.stats.studios": "Студии",
    "profile.stats.operators": "Операторы",
    "profile.stats.sessions": "Входов",
    "profile.stats.created": "В системе с",
    "profile.scope.global": "Полный доступ ко всем студиям, играм и операторам",
    "profile.scope.empty": "Доступы пока не выданы — обратитесь к администратору",
    "profile.changePasswordSubtitle": "Новый пароль от 8 символов",
    "profile.rule.length": "Не меньше 8 символов",
    "profile.rule.letter": "Есть буква",
    "profile.rule.digit": "Есть цифра",
    "profile.rule.different": "Отличается от текущего",
    "profile.strength.weak": "Слабый",
    "profile.strength.medium": "Средний",
    "profile.strength.good": "Хороший",
    "profile.strength.strong": "Надёжный",
    "profile.historySubtitle": "Устройства и входы в панель",
    "profile.noHistory": "История входа пока пустая",
    "profile.records": "записей",
    "profile.thisDevice": "Это устройство",
    "profile.wrongPassword": "Неверный пароль",
    "profile.failed": "Ошибка входа",
    "profile.error.image": "Формат до 5 МБ: PNG, JPG или WEBP",
    "profile.error.samePassword": "Новый пароль совпадает с текущим",
    "profile.image": "Изображение",
    "profile.name": "Имя",
    "profile.save": "Сохранить",
    "profile.savedSuccess": "Данные успешно сохранены",
    "profile.imageSaved": "Изображение успешно сохранено",
    "profile.imageDeleted": "Изображение успешно удалено",
    "profile.error.emptyName": "Введите имя",
    "profile.changePassword": "Изменить пароль",
    "profile.currentPassword": "Текущий пароль",
    "profile.newPassword": "Новый пароль",
    "profile.repeatPassword": "Повторите пароль",
    "profile.error.emptyCurrentPwd": "Введите текущий пароль",
    "profile.error.shortCurrentPwd": "Пароль должен быть больше 8 символов",
    "profile.error.emptyNewPwd": "Введите новый пароль",
    "profile.error.shortNewPwd": "Пароль должен быть больше 8 символов",
    "profile.error.mismatch": "Пароли не совпадают",
    "profile.passwordChanged": "Пароль успешно изменен!",
    "profile.error.wrongPassword": "Неверный пароль!",
    "profile.error.authError": "Ошибка авторизации!",
    "profile.historyTitle": "История входа",
    "profile.device": "Устройство",
    "profile.browser": "Браузер",
    "profile.ipAddress": "IP адрес",
    "profile.countryCity": "Страна, Город",
    "profile.lastActivity": "Последняя активность",

    /* Page 404 */
    "page404.text": "Страница, которую вы запрашивали, не существует.",

    /* Dealer pages */
    "dealer.title": "Дилерa",
    "dealer.add": "Добавить",
    "dealer.name": "Имя",
    "dealer.gamesCount": "Количество игр",
    "dealer.qrCode": "QR код",
    "dealer.downloadPng": "Скачать .PNG",
    "dealer.edit": "Редактировать",
    "dealer.delete": "Удалить",
    "dealer.addTitle": "Добавить дилера",
    "dealer.editTitle": "Редактировать дилера",
    "dealer.createSubtitle": "Выберите студию и назначьте доступ к столам",
    "dealer.editSubtitle": "Студию и доступ к столам можно изменить в любой момент",
    "dealer.dealerName": "Имя дилера",
    "dealer.studio": "Студия",
    "dealer.tables": "Столы",
    "dealer.tableAccess": "Доступ к столам",
    "dealer.tableAccessHint": "Дилер сможет работать только на выбранных столах своей студии",
    "dealer.selectStudioHint": "Сначала выберите студию — от неё зависит список доступных столов",
    "dealer.noStudio": "Студия не назначена",
    "dealer.noStudios": "Нет доступных студий",
    "dealer.studioLocked": "Студию дилера изменить нельзя",
    "dealer.noTables": "В этой студии пока нет столов",
    "dealer.generatePin": "Сгенерировать PIN",
    "dealer.searchByName": "Поиск по имени дилера",
    "dealer.nothingFound": "Дилеры не найдены",
    "dealer.empty": "Дилеров пока нет",
    "dealer.viewOnly": "Только просмотр",
    "dealer.error.emptyName": "Введите имя дилера",
    "dealer.error.emptyPin": "Введите PIN/Barcode",
    "dealer.error.pinLength": "Длина PIN/штрих-кода должна быть 6 символов",
    "dealer.error.selectStudio": "Выберите студию",
    "dealer.addedSuccess": "Дилер успешно добавлен",
    "dealer.savedSuccess": "Дилер успешно сохранен",
    "dealer.deletedSuccess": "Дилер успешно удален",
    "dealer.added": "Дилер добавлен",
    "dealer.removed": "Дилер убран",

    /* Currency pages */
    "currency.title": "Валюты",
    "currency.name": "Название",
    "currency.code": "Код",
    "currency.symbol": "Символ",
    "currency.add": "Добавить",
    "currency.edit": "Редактировать",
    "currency.delete": "Удалить",
    "currency.addTitle": "Добавить валюту",
    "currency.editTitle": "Редактировать валюту",
    "currency.createSubtitle": "Код, символ и коэффициент фишки валюты",
    "currency.editSubtitle": "Изменения применятся сразу на всех столах",
    "currency.symbolBefore": "Ставить символ после цифры",
    "currency.chipRate": "Коэффициент фишки",
    "currency.chipRateShort": "Коэф. фишки",
    "currency.chipRateHint": "На это число умножается номинал фишки в этой валюте",
    "currency.usedOn": "Столы",
    "currency.searchByName": "Поиск по названию или коду",
    "currency.nothingFound": "Валюты не найдены",
    "currency.empty": "Валют пока нет",
    "currency.superadminOnly": "Только суперадмин",
    "currency.error.emptyName": "Введите название валюты",
    "currency.error.emptyCode": "Введите код валюты",
    "currency.error.codeLength": "Длина кода должна быть 3 символа",
    "currency.error.emptySymbol": "Введите символ валюты",
    "currency.error.chipRate": "Введите корректный коэффициент фишки",
    "currency.addedSuccess": "Валюта успешно добавлена",
    "currency.savedSuccess": "Валюта успешно cохранена",
    "currency.deletedSuccess": "Валюта успешно удалена",
    "currency.alreadyAdded": "Валюта уже добавлена",
    "currency.selectCurrency": "Выберите валюту",
    "currency.maxBet": "Максимальная ставка",
    "currency.minBonusBet": "Минимальная ставка для бонуса",
    "currency.maxBonusBet": "Максимальная ставка для бонуса",
    "currency.minBet": "Минимальная ставка",
    "currency.maxPay": "Максимальная выплата",
    "currency.chips": "Фишки (пишите через запятую)",
    "currency.maxPP": "Максимальная PERFECT PAIR",
    "currency.max21": "Максимальная 21+3",
    "currency.maxBust": "Максимальная BUST",
    "currency.maxCS": "Максимальная CRAZY SEVEN",
    "currency.maxBetShort": "Макс. ставка",
    "currency.minBetShort": "Мин. ставка",
    "currency.maxPayShort": "Макс. выплата",
    "currency.chipsLabel": "Фишки",
    "currency.create": "Создать",
    "currency.enterCurrency": "Выберите валюту",
    "currency.enterMaxBet": "Введите максимальную ставку",
    "currency.enterMaxPP": "Введите максимальную PERFECT PAIR",
    "currency.enterMax21": "Введите максимальную 21+3",
    "currency.enterMaxBust": "Введите максимальную BUST",
    "currency.enterMaxCS": "Введите максимальную CRAZY SEVEN",
    "currency.enterMinBet": "Введите минимальную ставку",
    "currency.enterMaxPay": "Введите максимальную выплату",
    "currency.enterChips": "Введите список фишек",
    "currency.maxBonusShort": "Макс. бонус",
    "currency.emptyOnTable": "На столе пока нет валют",
    "currency.allAdded": "Все валюты уже добавлены",
    "currency.limits": "Лимиты ставок",
    "currency.limitsSubtitle": "Лимиты действуют только на этом столе",
    "currency.sideBets": "Дополнительные ставки",
    "currency.applyToAll": "Применить ко всем валютам игры",
    "currency.applyToAllHint": "Все валюты стола станут копией доллара: лимиты и номиналы фишек умножатся на коэффициент валюты, а количество фишек и их цвета возьмутся от доллара.",
    "currency.chipsHint": "Номиналы фишек через запятую, например 1,5,25,100",

    /* Card pages */
    "card.title": "Карты",
    "card.value": "Значение",
    "card.barcode": "Barcode",
    "card.card": "Карта",
    "card.changed": "Изменено",

    /* Card list */
    "card.total": "Всего карт",
    "card.suits": "Мастей",
    "card.filled": "С barcode",
    "card.doubles": "Дубликаты",
    "card.duplicate": "Дубликат",
    "card.noBarcode": "Нет barcode",
    "card.empty": "Колода пуста",

    /* Card suits */
    "card.suit.heart": "Черви",
    "card.suit.diamond": "Бубны",
    "card.suit.club": "Трефы",
    "card.suit.spade": "Пики",
    "card.suit.other": "Другие",

    /* Card modal */
    "card.editTitle": "Изменить Barcode",
    "card.barcodeHint": "Barcode — код карты для сканера. Латинские буквы, цифры, точка, дефис и подчёркивание, до 32 символов.",
    "card.busyHint": "Этот barcode уже стоит на карте",
    "card.savedSuccess": "Barcode успешно сохранен",
    "card.error.emptyBarcode": "Введите Barcode",
    "card.error.formatBarcode": "Только латинские буквы, цифры, точка, дефис и подчёркивание",
    "card.error.busyBarcode": "Этот barcode уже занят другой картой",

    /* Operator page */
    "operator.title": "Операторы",
    "operator.name": "Название",
    "operator.edit": "Редактировать",
    "operator.delete": "Удалить",
    "operator.addTitle": "Добавить оператора",
    "operator.editTitle": "Редактировать оператора",
    "operator.createSubtitle": "Реквизиты интеграции и доступ к столам",
    "operator.editSubtitle": "Изменения применятся сразу ко всем играм оператора",
    "operator.mainSection": "Основное",
    "operator.integrationSection": "Интеграция",
    "operator.tables": "Столы",
    "operator.managers": "Менеджеры",
    "operator.tableAccess": "Доступ к столам",
    "operator.tableAccessHint": "Оператор сможет открывать только выбранные столы",
    "operator.pathHint": "Startpoint — адрес оператора, остальные поля это пути к нему (например /api/balance)",
    "operator.licenseNumber": "Номер лицензии",
    "operator.noStartpoint": "Startpoint не указан",
    "operator.noTables": "Столов пока нет",
    "operator.withoutStudio": "Без студии",
    "operator.searchByName": "Поиск по названию или Slug",
    "operator.nothingFound": "Операторы не найдены",
    "operator.empty": "Операторов пока нет",
    "operator.superadminOnly": "Только суперадмин",
    "operator.token": "Токен",
    "operator.tokenTitle": "Токен оператора",
    "operator.tokenEmpty": "Токен не создан",
    "operator.tokenHint": "Токен нужен оператору для запросов к API. После обновления старый токен перестанет работать",
    "operator.tokenButton": "Обновить токен",
    "operator.tokenConfirm": "Обновить токен оператора?",
    "operator.tokenSuccess": "Токен успешно обновлен",
    "operator.tokenCopied": "Токен скопирован",
    "operator.copyToken": "Скопировать токен",
    "operator.copyFailed": "Не удалось скопировать токен",
    "operator.error.emptyName": "Введите название оператора",
    "operator.error.emptySlug": "Введите Slug оператора",
    "operator.error.slugFormat": "Slug может содержать только латинские буквы, цифры, дефис и подчеркивание",
    "operator.error.emptyStartpoint": "Введите Startpoint",
    "operator.error.startpointFormat": "Startpoint должен начинаться с http:// или https://",
    "operator.error.emptyBalance": "Введите Balance URL",
    "operator.error.emptyDebit": "Введите Debit URL",
    "operator.error.emptyCredit": "Введите Credit URL",
    "operator.error.pathFormat": "Путь должен начинаться с /",
    "operator.addedSuccess": "Оператор успешно добавлен",
    "operator.savedSuccess": "Оператор успешно сохранен",
    "operator.deletedSuccess": "Оператор успешно удален",

    /* Bonus page */
    "bonus.notFound": "По вашему запросу ничего не найдено",
    "bonus.operator": "Оператор",
    "bonus.game": "Игра",
    "bonus.player": "Игрок",
    "bonus.bet": "Ставка",
    "bonus.win": "Выигрыш",
    "bonus.date": "Дата",
    "bonus.info": "Информация",
    "bonus.number": "Номер",
    "bonus.gameNumber": "Номер игры #",
    "bonus.exchangeRate": "Курс валют (к доллару США)",
    "bonus.combination": "Комбинация",
    "bonus.multiplier": "Умножитель",
    "bonus.cash": "Касса",
    "bonus.filter": "Фильтр",
    "bonus.operators": "Операторы",
    "bonus.search": "Поиск по номеру игры или по коду игрока",
    "bonus.title": "Бонус",
    "bonus.settings": "Настройки",
    "bonus.games": "Игры",
    "bonus.reset": "Сбросить",
    "bonus.jackpotNotConnected": "не подключен",
    "bonus.connectJackpot": "Подключите ДЖЕКПОТ к оператору",
    "bonus.connect": "Подключить",
    "bonus.cashRegister": "КАССА",
    "bonus.active": "Активен",
    "bonus.disabled": "Отключен",
    "bonus.jackpotSettings": "Настройки JACKPOT",

    /* Studio pages */
    "studio.title": "Cтудии",
    "studio.name": "Название",
    "studio.code": "Код",
    "studio.token": "Токен",
    "studio.edit": "Редактировать",
    "studio.delete": "Удалить",
    "studio.add": "Добавить",
    "studio.deleteConfirm": "Вы действительно хотите удалить студию?",
    "studio.deleteWarning": "Невозможно восстановить после изменений",
    "studio.deleteButton": "Да, удалить",
    "studio.deletedSuccess": "Cтудия успешно удалена!",
    "studio.createdTitle": "Cоздать студию",
    "studio.editTitle": "Редактировать",
    "studio.savedSuccess": "Данные успешно сохранены!",
    "studio.nameLabel": "Название",
    "studio.codeLabel": "Код",
    "studio.error.emptyName": "Введите название",
    "studio.error.emptyCode": "Введите код",
    "studio.error.emptyServiceURL": "Введите Service URL",
    "studio.error.emptySocketURL": "Введите Socket URL",
    "studio.createdSuccess": "Студия успешно создана!",
    "studio.addresses": "Адреса",
    "studio.content": "Содержимое",
    "studio.tables": "Столы",
    "studio.dealers": "Дилеры",
    "studio.admins": "Доступ у админов",
    "studio.empty": "Студии не найдены",
    "studio.viewOnly": "Только просмотр",
    "studio.tokenCopied": "Токен скопирован!",
    "studio.createSubtitle": "Новая студия и адреса ее сервера",
    "studio.editSubtitle": "Данные студии и адреса ее сервера",
    "studio.mainSection": "Основное",
    "studio.addressSection": "Адреса сервера",
    "studio.addressHint": "Service URL — управление стримами, Socket URL — подключение к трансляции, Record URL — архив записей. Ссылка сохраняется без слеша в конце.",

    /* Studio stream */
    "studio.streams": "Стримы",
    "studio.participants": "Участники",
    "studio.video": "Видео",
    "studio.audio": "Аудио",
    "studio.allTime": "За все время",
    "studio.load": "Загруженность",
    "studio.yes": "Да",
    "studio.no": "Нет",
    "studio.streamTitle": "Трансляции студии",
    "studio.streamSubtitle": "Состояние стриминг сервера",
    "studio.refresh": "Обновить",
    "studio.archive": "Архив",
    "studio.openLink": "Открыть ссылку",
    "studio.liveStreams": "Активные трансляции",
    "studio.noStreams": "Активных трансляций нет",

    /* Studio room (stream control) */
    "studio.disableStreamTitle": "Отключить стрим?",
    "studio.disableStreamText": "Вы действительно хотите отключить стрим?",
    "studio.disableStreamButton": "Отключить",
    "studio.disabledSuccess": "Успешно отключено!",
    "studio.participantsSubtitle": "Участники трансляции",
    "studio.noParticipants": "В трансляции никого нет",
    "studio.publisher": "Вещает",
    "studio.viewer": "Смотрит",
    "studio.publisherLocked": "Источник трансляции нельзя отключить",

    /* Message page */
    "message.title": "Сообщение",
    "message.player": "Игрок",
    "message.game": "Игра",
    "message.text": "Сообщение",
    "message.dateTime": "Дата и время",
    "message.tables": "Столы",
    "message.selectTable": "Выберите столы для фильтра",
    "message.empty": "Сообщений пока нет",
    "message.loadMore": "Загрузить ещё",
    "message.loading": "Загрузка ...",

    /* Messages section */
    "msg.title": "Сообщения",
    "msg.search": "Игрок, текст, номер игры или дилер",
    "msg.filter": "Фильтр",
    "msg.player": "Игрок",
    "msg.game": "Игра",
    "msg.operator": "Оператор",
    "msg.tester": "Тестировщик",
    "msg.text": "Сообщение",
    "msg.dealer": "Дилер",
    "msg.date": "Дата",
    "msg.noGame": "Игра удалена",
    "msg.empty": "Сообщений пока нет",
    "msg.nothingFound": "Ничего не найдено",
    "msg.openPlayer": "Открыть игрока",
    "msg.copyText": "Скопировать сообщение",
    "msg.copied": "Скопировано!",
    "msg.copyFailed": "Не удалось скопировать",

    /* Messages numbers */
    "msg.total": "Сообщений",
    "msg.playersCount": "Игроков",
    "msg.gamesCount": "Игр",
    "msg.dealersCount": "Дилеров",
    "msg.lastMessage": "Последнее",

    /* Messages filter */
    "msg.filterTitle": "Фильтр сообщений",
    "msg.filterSubtitle": "Период, операторы и игры вашего доступа",
    "msg.period": "Период",
    "msg.dateFrom": "Дата с",
    "msg.dateTo": "Дата по",
    "msg.players": "Игроки",
    "msg.includeTesters": "Показывать тестовых",
    "msg.operators": "Операторы",
    "msg.games": "Игры",
    "msg.searchByGame": "Поиск по игре или студии",
    "msg.gamesEmpty": "Доступных игр нет",
    "msg.filterHint": "Пустой выбор — значит все игры вашего доступа. Отметьте нужные, чтобы сузить список.",
    "msg.reset": "Сбросить",

    /* Messages tabs and censor mark */
    "msg.tab.all": "Все сообщения",
    "msg.tab.censored": "С матом",
    "msg.censored": "Цензура",
    "msg.censoredCount": "С матом",
    "msg.censoredHint": "Игроки за столом прочитали *** вместо запрещённого слова, здесь текст показан как есть",
    "msg.emptyCensored": "Мат за этот период не встречался",

    /* Censor dictionary */
    "censor.tab": "Словарь мата",
    "censor.search": "Слово или примечание",
    "censor.word": "Слово",
    "censor.wordLabel": "Слово или корень",
    "censor.wordHint": "Регистр, латиница вместо кириллицы, цифры вместо букв, пробелы и точки внутри слова роли не играют: «х у й», «Х.У.Й» и «хууй» — это одно и то же слово.",
    "censor.type": "Тип",
    "censor.type.root": "Корень",
    "censor.type.exact": "Точное слово",
    "censor.type.rootHint": "Корень ловится в любом месте слова — «пизд» закроет сразу все формы. Не берите корни, которые встречаются в обычных словах.",
    "censor.type.exactHint": "Точное слово срабатывает только как отдельное слово — «бля» не тронет «рубля».",
    "censor.comment": "Примечание",
    "censor.status": "Статус",
    "censor.author": "Автор",
    "censor.on": "Включено",
    "censor.off": "Выключено",
    "censor.total": "Слов в словаре",
    "censor.active": "Включено",
    "censor.inactive": "Выключено",
    "censor.empty": "Словарь пуст",
    "censor.note": "Словарь один для всех игр. Игровые серверы держат его в памяти и перечитывают сразу после изменения — перезапуск не нужен. В чате слово целиком заменяется на ***, а в базе сообщение остаётся как есть.",
    "censor.add": "Добавить слово",
    "censor.save": "Сохранить",
    "censor.edit": "Изменить слово",
    "censor.delete": "Удалить слово",
    "censor.switchOn": "Включить",
    "censor.switchOff": "Выключить",
    "censor.createTitle": "Новое слово",
    "censor.editTitle": "Изменить слово",
    "censor.formSubtitle": "Запрещённое слово для чатов всех игр",
    "censor.created": "Слово добавлено",
    "censor.updated": "Слово изменено",
    "censor.deleted": "Слово удалено",
    "censor.switchedOn": "Слово включено",
    "censor.switchedOff": "Слово выключено",
    "censor.deleteConfirm": "Удалить слово из словаря?",
    "censor.deleteButton": "Удалить",
    "censor.error.empty": "Введите слово",
    "censor.error.long": "Слово слишком длинное",

    /* Notification panels */
    "notification.title": "Уведомления",
    "notification.subtitle": "События ваших столов",
    "notification.records": "записей",
    "notification.unread": "новых",
    "notification.readAll": "Прочитать все",
    "notification.empty": "Здесь пока нет уведомлений",
    "notification.new": "Новый",
    "notification.go": "Перейти",
    "notification.goTable": "Перейти к столу",
    "notification.pauseTitle": "Игра на паузе",
    "notification.pauseText": "Стол остановил игру и ждёт решения",
    "notification.alsoPaused": "Ещё на паузе",

    /* Support chat */
    "support.title": "Cлужба поддержки",
    "support.inputPlaceholder": "Введите сообщение...",
    "support.searchPlaceholder": "Поиск по игроку или игре",
    "support.notFound": "Ничего не найдено",
    "support.you": "Вы",
    "support.today": "Сегодня",
    "support.yesterday": "Вчера",
    "support.playerType": "Игрок",
    "support.adminType": "Админ",
    "support.noMessages": "Здесь пока нет сообщений",
    "support.noMessagesDesc": "В службу поддержки ещё не обращался",
    "support.messageSent": "Сообщение успешно отправлено",
    "support.emptyMessage": "Введите сообщение",
    "support.messagePlaceholder": "Сообщение",

    /* Table / Control widget */
    "table.bridgeConnected": "Подключено к Bridge",
    "table.bridgeError": "Ошибка Bridge",
    "table.noGameConnection": "Нет подключение с игрой!",
    "table.save": "Сохранить",
    "table.visibility": "Видимость стола",
    "table.visibilityDesc": "Сделайте стол публичным или скрытым",
    "table.free": "Стол свободен",
    "table.busy": "Стол занят",
    "table.autoDetected": "Определяется автоматический",
    "table.access": "Доступ к столу (открыть/закрыть смену)",
    "table.accessDesc": "Разрешить или запретить вход на стол",
    "table.closed": "Cтол закрыт",
    "table.working": "Cтол работает",
    "table.allDay": "Круглосуточно",
    "table.allDayDesc": "Круглосуточная работа",
    "table.startTime": "Время начала работы",
    "table.endTime": "Время окончания работы",
    "table.error.emptyStart": "Введите время",
    "table.error.emptyEnd": "Введите время",
    "table.deleteConfirm": "Удалить игру?",
    "table.deleteWarning": "После удаления восстановить невозможно.",
    "table.deleteCancel": "Отменить",
    "table.deleteButton": "Удалить",
    "table.deletedSuccess": "Игра удалена!",

    /* Table / Dealer widget */
    "table.dealerAdded": "Дилер добавлен",
    "table.dealerRemoved": "Дилер убран",

    /* Table / Refunds */
    "table.refundTxNumber": "Номер транзакции",
    "table.refundName": "Название",
    "table.refundAmount": "Сумма",
    "table.refundAmountUSD": "Сумма (USD)",
    "table.refundStatus": "Статус",
    "table.refundAdmin": "Админ",
    "table.refundDateTime": "Дата и время",
    "table.refundSuccess": "Успешно",

    /* Bonus widgets */
    "jackpot.notConnected": "JACKPOT не подключен",
    "jackpot.connectDesc": "Подключите ДЖЕКПОТ к оператору",
    "jackpot.connect": "Подключить",
    "jackpot.cash": "КАССА",
    "jackpot.active": "Активен",
    "jackpot.disabled": "Отключен",
    "jackpot.settings": "Настройки JACKPOT",
    "jackpot.selectOperator": "Выберите оператора",
    "jackpot.cashLabel": "Касса, $",
    "jackpot.visibility": "Видимость",
    "jackpot.connectButton": "Соединить",

    /* Timezone */
    "timezone.title": "Выберите часовой пояс",
    "timezone.confirmTitle": "Ваш часовой пояс",
    "timezone.confirmText": "Определён по вашему устройству. Верно?",
    "timezone.yes": "Да, верно",
    "timezone.change": "Изменить",

    /* RSG Reports */
    "rsg.title": "Отчёты RSG",
    "rsg.gamesTitle": "Игры RSG",
    "rsg.tabReports": "Отчёты",
    "rsg.tabGames": "Игры",

    /* RSG Reports — list */
    "rsg.fileName": "Файл",
    "rsg.reportDate": "Период отчёта",
    "rsg.sentAt": "Дата отправки",
    "rsg.status": "Статус",
    "rsg.ggr": "GGR",
    "rsg.games": "Игры",
    "rsg.uploaded": "Отправлен",
    "rsg.notUploaded": "Не отправлен",
    "rsg.allTypes": "Все типы",
    "rsg.searchByFile": "Файл или хэш",
    "rsg.reportsEmpty": "Отчёты не найдены",
    "rsg.nothingFound": "Ничего не найдено",

    /* RSG Reports — detail modal */
    "rsg.detailTitle": "Детали отчёта",
    "rsg.detailSubtitle": "Всё, что получил регулятор",
    "rsg.totals": "Итоги",
    "rsg.information": "Об отчёте",
    "rsg.amountIn": "Приход",
    "rsg.amountOut": "Расход",
    "rsg.noHash": "Хэш отсутствует",
    "rsg.copyHash": "Скопировать хэш",
    "rsg.hashCopied": "Хэш скопирован",
    "rsg.copyFailed": "Не удалось скопировать",
    "rsg.fileDownload": "Скачать XML",
    "rsg.fileMissing": "Файл недоступен на сервере",
    "rsg.fileMissingHint": "XML файл не найден на диске — скачать его нельзя. Отчёт уже ушёл регулятору, здесь остались только данные.",
    "rsg.fileRegenerated": "пересобран",
    "rsg.fileRegeneratedHint": "Отчёт пересобран после отправки — скачается версия новее отправленной:",
    "rsg.searchByGame": "Стол или ID игры",
    "rsg.empty": "В этом отчёте нет игр",

    /* RSG Games — list */
    "rsg.tableName": "Стол",
    "rsg.studio": "Студия",
    "rsg.gameID": "ID игры RSG",
    "rsg.gameIDPlaceholder": "Не задан",
    "rsg.allTables": "Все столы",
    "rsg.searchByTable": "Стол, студия или ID игры",
    "rsg.gamesEmpty": "Столы не найдены",
    "rsg.inReport": "В отчёте",
    "rsg.notInReport": "Отключён",
    "rsg.noGameID": "Нет ID игры",
    "rsg.state.active": "В отчёте",
    "rsg.state.off": "Отключены",
    "rsg.state.empty": "Без ID игры",
    "rsg.superadminOnly": "Только суперадмин",

    /* RSG Games — form modal */
    "rsg.gameTitle": "ID игры RSG",
    "rsg.gameIDHint": "Идентификатор выдаёт регулятор. Пустое значение убирает стол из отчётов.",
    "rsg.reportState": "Участие в отчётах",
    "rsg.inReportNote": "Данные стола попадут в следующий отчёт",
    "rsg.notInReportNote": "Стол не попадает в отчёты",
    "rsg.gameIDSaved": "ID игры сохранён",
    "rsg.gameIDRemoved": "ID игры удалён",
    "rsg.error.gameIDFormat": "ID может содержать только латинские буквы, цифры, точку, дефис и подчеркивание",

    /* GAME TRANSACTIONS */
    "gtx.title": "Транзакции",
    "gtx.search": "Игрок, ID, номер транзакции, номер раунда",
    "gtx.operator": "Оператор",
    "gtx.game": "Игра",
    "gtx.games": "Игры",
    "gtx.selectGame": "Выберите игры для фильтра",
    "gtx.player": "Игрок",
    "gtx.playerName": "Имя игрока",
    "gtx.playerID": "ID игрока",
    "gtx.reason": "Причина",
    "gtx.status": "Статус",
    "gtx.type": "Тип",
    "gtx.amount": "Сумма",
    "gtx.amountUSD": "Сумма в USD",
    "gtx.balance": "Баланс",
    "gtx.balanceBefore": "Баланс до",
    "gtx.balanceAfter": "Баланс после",
    "gtx.refund": "Возврат",
    "gtx.date": "Дата",
    "gtx.success": "Успешно",
    "gtx.failed": "Ошибка",
    "gtx.pending": "В ожидании",
    "gtx.debit": "Списание",
    "gtx.credit": "Начисление",
    "gtx.allStatuses": "Все статусы",
    "gtx.allTypes": "Все типы",
    "gtx.allRefunds": "Все",
    "gtx.isRefund": "Только возвраты",
    "gtx.notRefund": "Без возвратов",
    "gtx.reset": "Сбросить",
    "gtx.empty": "Транзакций не найдено",
    "gtx.detailTitle": "Подробнее о транзакции",
    "gtx.main": "Основное",
    "gtx.transaction": "Транзакция",
    "gtx.money": "Деньги",
    "gtx.dates": "Даты",
    "gtx.number": "Номер транзакции",
    "gtx.round": "Номер раунда",
    "gtx.session": "Сессия",
    "gtx.box": "Бокс",
    "gtx.admin": "Администратор",
    "gtx.currency": "Валюта",
    "gtx.rate": "Курс к USD",
    "gtx.createdAt": "Создана",
    "gtx.updatedAt": "Обновлена",
    "gtx.result": "Результат (ответ оператора)",
    "gtx.noResult": "Ответа от оператора ещё нет",
    "gtx.roundTransactions": "Транзакции раунда",
    "gtx.tester": "Тестировщик",
    "gtx.yes": "Да",
    "gtx.no": "Нет",
    "gtx.includeTesters": "Включить тестовых игроков",
    "gtx.includeVips": "Включить VIP игроков",
    "gtx.totalDebit": "Списано (Debit)",
    "gtx.totalCredit": "Начислено (Credit)",
    "gtx.totalNet": "Разница (Debit − Credit)",
    "gtx.summaryCount": "тр.",

    /* GAME TRANSACTIONS — СПИСОК */
    "gtx.filter": "Фильтр",
    "gtx.studio": "Студия",
    "gtx.operators": "Операторы",
    "gtx.players": "Игроки",
    "gtx.noGame": "Игра не указана",
    "gtx.nothingFound": "Ничего не найдено",
    "gtx.detailSubtitle": "Что произошло с деньгами",
    "gtx.copyNumber": "Копировать номер транзакции",
    "gtx.copied": "Номер скопирован",
    "gtx.copyFailed": "Не удалось скопировать",
    "gtx.playerType": "Тип игрока",
    "gtx.regular": "Обычный",
    "gtx.ago": "Прошло времени",

    /* GAME TRANSACTIONS — ЦИФРЫ */
    "gtx.total": "Транзакций",
    "gtx.playersCount": "Игроков",
    "gtx.vipsCount": "VIP игроков",
    "gtx.failedCount": "Неуспешных",
    "gtx.refundsCount": "Возвратов",
    "gtx.netPositive": "в пользу казино",
    "gtx.netNegative": "в пользу игроков",

    /* GAME TRANSACTIONS — ФИЛЬТР */
    "gtx.filterTitle": "Фильтр транзакций",
    "gtx.filterSubtitle": "Период, статус, операторы и игры",
    "gtx.period": "Период",
    "gtx.dateFrom": "Дата с",
    "gtx.dateTo": "Дата по",
    "gtx.searchByGame": "Стол, слаг или студия",
    "gtx.gamesEmpty": "Доступных игр нет",
    "gtx.filterHint": "Пустой выбор означает все доступные операторы и игры. Показываются только те, к которым есть доступ.",

    /* BONUS */
    "bns.title": "Бонус",
    "bns.search": "Игрок, номер игры, номер бонуса или комбинация",
    "bns.filter": "Фильтр",
    "bns.settings": "JACKPOT",
    "bns.player": "Игрок",
    "bns.game": "Игра",
    "bns.games": "Игры",
    "bns.studio": "Студия",
    "bns.operator": "Оператор",
    "bns.operators": "Операторы",
    "bns.players": "Игроки",
    "bns.bet": "Ставка",
    "bns.win": "Выигрыш",
    "bns.jackpot": "JACKPOT",
    "bns.cash": "Касса",
    "bns.date": "Дата",
    "bns.tester": "Тестировщик",
    "bns.round": "Раунд",
    "bns.gameNumber": "Номер игры",
    "bns.combination": "Комбинация",
    "bns.multiplier": "Умножитель",
    "bns.rate": "Курс к USD",
    "bns.result": "Результат",
    "bns.allResults": "Все раунды",
    "bns.onlyWins": "Только выигрыши",
    "bns.onlyLoses": "Без выигрыша",
    "bns.pools": "Распределение ставки",
    "bns.poolBefore": "Было",
    "bns.poolShare": "Взнос со ставки",
    "bns.poolAfter": "Стало",
    "bns.noGame": "Игра не указана",
    "bns.empty": "Бонусных ставок пока нет",
    "bns.nothingFound": "Ничего не найдено",
    "bns.detailTitle": "Бонусная ставка",
    "bns.detailWin": "Выигрыш по бонусу",
    "bns.copyNumber": "Копировать номер игры",
    "bns.copied": "Номер скопирован",
    "bns.copyFailed": "Не удалось скопировать",

    /* BONUS — ЦИФРЫ */
    "bns.total": "Ставок",
    "bns.playersCount": "Игроков",
    "bns.winsCount": "Выигрышей",
    "bns.gamesCount": "Игр",
    "bns.maxWin": "Макс. выигрыш",
    "bns.totalBets": "Сумма ставок",
    "bns.totalWins": "Сумма выплат",
    "bns.totalNet": "Разница (Ставки − Выплаты)",
    "bns.jackpotShare": "В JACKPOT:",
    "bns.summaryCount": "раунд.",
    "bns.netPositive": "в пользу казино",
    "bns.netNegative": "в пользу игроков",

    /* BONUS — ФИЛЬТР */
    "bns.filterTitle": "Фильтр бонусов",
    "bns.filterSubtitle": "Период, результат, операторы и игры",
    "bns.period": "Период",
    "bns.dateFrom": "Дата с",
    "bns.dateTo": "Дата по",
    "bns.includeTesters": "Включить тестовых игроков",
    "bns.includeVips": "Включить VIP игроков",
    "bns.searchByGame": "Стол, слаг или студия",
    "bns.gamesEmpty": "Доступных игр нет",
    "bns.filterHint": "Пустой выбор означает все доступные операторы и игры. Показываются только те, к которым есть доступ.",
    "bns.reset": "Сбросить",

    /* BONUS — НАСТРОЙКИ JACKPOT */
    "bns.jackpotTitle": "Настройки JACKPOT",
    "bns.jackpotSubtitle": "Призовой фонд и касса каждого оператора",
    "bns.jackpotTotal": "Общий JACKPOT",
    "bns.cashTotal": "Общая касса",
    "bns.connectedCount": "Подключено",
    "bns.activeCount": "активны:",
    "bns.statusActive": "Виден игрокам",
    "bns.statusDisabled": "Скрыт",
    "bns.jackpotEmpty": "JACKPOT ещё не подключён",
    "bns.jackpotEmptyText": "Подключите JACKPOT к оператору — призовой фонд начнёт расти со ставок игроков",
    "bns.connect": "Подключить",
    "bns.jackpotHint": "Нажмите на оператора, чтобы изменить суммы",
    "bns.updateSubtitle": "Призовой фонд, касса и видимость",
    "bns.wasAmount": "Было:",
    "bns.visibility": "Видимость JACKPOT",
    "bns.visibilityOn": "Игроки видят призовой фонд в игре",
    "bns.visibilityOff": "Призовой фонд скрыт от игроков",
    "bns.connectTitle": "Подключение JACKPOT",
    "bns.connectSubtitle": "Выберите оператора и задайте стартовые суммы",
    "bns.allPools": "Все пулы",
    "bns.testersOnly": "Только для тестеров",
    "bns.testersOnlyOn": "Пул на обкатке: ставку делают и выигрывают только тестовые аккаунты",
    "bns.testersOnlyOff": "Обычный режим: ставку делают все игроки, кроме тестовых",
    "bns.pool": "Пул джекпота",
    "bns.poolElectron": "Электронные игры",
    "bns.poolLive": "Живые игры",
    "bns.startAmounts": "Стартовые суммы",
    "bns.selectOperator": "Выберите оператора",
    "bns.operatorConnected": "Уже подключён",
    "bns.operatorFree": "Свободен",
    "bns.operatorsEmpty": "Операторов нет",
    "bns.allConnected": "Все операторы уже подключены к JACKPOT",
    "bns.searchByOperator": "Поиск по названию оператора",

    /* LOGS */
    "log.title": "Логи",
    "log.game": "Игра",
    "log.games": "Игры",
    "log.studio": "Студия",
    "log.table": "Слаг стола",
    "log.type": "Тип",
    "log.message": "Сообщение",
    "log.date": "Дата",

    /* LOGS LIST */
    "log.search": "Текст ошибки или слаг стола",
    "log.filter": "Фильтр",
    "log.total": "Записей",
    "log.range": "Период",
    "log.lastRecord": "Последняя запись",
    "log.cut": "текст обрезан",
    "log.noMessage": "Сообщение пустое",
    "log.noTable": "Стол не указан",
    "log.empty": "Логов пока нет",
    "log.nothingFound": "Ничего не найдено",
    "log.copied": "Сообщение скопировано",
    "log.copyFailed": "Не удалось скопировать",

    /* LOGS AGO */
    "log.ago.now": "только что",
    "log.ago.minutes": "мин",
    "log.ago.hours": "ч",
    "log.ago.days": "дн",
    "log.ago.suffix": "назад",

    /* LOGS DETAIL MODAL */
    "log.detailTitle": "Подробнее о записи",
    "log.information": "Об записи",
    "log.copy": "Копировать",
    "log.copyMessage": "Копировать сообщение",
    "log.noStudio": "Студия неизвестна",
    "log.tableMissingHint": "Такого слага больше нет в столах — стол переименовали или удалили, а записи остались.",
    "log.repeats": "Повторы",
    "log.repeatsMany": "Сообщение повторяется",
    "log.repeatsOnce": "Единичный случай",
    "log.repeatsOnceNote": "Такое сообщение по этому столу встречается впервые",
    "log.repeatsFirst": "впервые",
    "log.repeatsLast": "последний раз",
    "log.around": "Рядом по этому столу",
    "log.aroundEmpty": "Других записей по этому столу нет",
    "log.before": "раньше",
    "log.after": "позже",

    /* LOGS FILTER MODAL */
    "log.filterTitle": "Фильтр логов",
    "log.filterSubtitle": "Период, тип и игры",
    "log.period": "Период",
    "log.dateFrom": "Дата с",
    "log.dateTo": "Дата по",
    "log.allTypes": "Все типы",
    "log.searchByGame": "Стол, слаг или студия",
    "log.gamesEmpty": "Столов с логами нет",
    "log.gamesHint": "Пустой выбор означает все игры. Рядом с каждым столом — сколько записей он написал.",
    "log.reset": "Сбросить",

    /* BOOKING PAGE */
    "book.title": "Бронь VIP",
    "book.search": "Игрок, ID, комментарий или админ",
    "book.filter": "Фильтр",
    "book.create": "Забронировать",
    "book.game": "Игра",
    "book.games": "Игры",
    "book.player": "Игрок",
    "book.playerID": "ID игрока",
    "book.window": "Время",
    "book.status": "Статус",
    "book.author": "Создал",
    "book.operator": "Оператор",
    "book.operators": "Операторы",
    "book.comment": "Комментарий",

    /* BOOKING TABS */
    "book.tab.upcoming": "Предстоящие",
    "book.tab.history": "История",

    /* BOOKING STATES */
    "book.state.booked": "Забронировано",
    "book.state.soon": "Скоро начало",
    "book.state.live": "Идёт сейчас",
    "book.state.arrived": "Игрок явился",
    "book.state.missed": "Не явился",
    "book.state.cancelled": "Отменена",

    /* BOOKING TIME */
    "book.today": "Сегодня",
    "book.tomorrow": "Завтра",
    "book.yesterday": "Вчера",
    "book.in": "через",
    "book.leftUntilEnd": "до конца",
    "book.ended": "завершилась",
    "book.ago": "назад",
    "book.cancelledAt": "отменена",
    "book.unit.minutes": "мин",
    "book.unit.hours": "ч",
    "book.unit.days": "дн",

    /* BOOKING EMPTY STATES */
    "book.noGame": "Игра удалена",
    "book.noName": "Имя неизвестно",
    "book.tester": "ТЕСТ",
    "book.nothingFound": "Ничего не найдено",
    "book.noGames": "VIP игр нет",
    "book.noOperators": "Доступных операторов нет",
    "book.emptyUpcoming": "Предстоящих броней нет",
    "book.emptyUpcomingNote": "Здесь появятся брони, время которых ещё не прошло. Нажмите «Забронировать», чтобы держать VIP стол за игроком.",
    "book.emptyHistory": "В истории пока пусто",

    /* BOOKING FORM */
    "book.createTitle": "Новая бронь",
    "book.createSubtitle": "Оператор, игрок, VIP игра и время",
    "book.createButton": "Создать бронь",
    "book.createdSuccess": "Бронь создана",
    "book.selectOperatorFirst": "Сначала выберите оператора — список VIP игр зависит от него",
    "book.searchByGame": "Стол или студия",
    "book.checkingPlayer": "Проверяем ID игрока…",
    "book.unknownPlayer": "Игрок с таким ID ещё не заходил в игры. Бронь создать можно, но проверьте ID ещё раз.",
    "book.commentPlaceholder": "Например: гость придёт с сопровождением, стол держать до 23:00",
    "book.lengthHint": "Стол будет занят",
    "book.from": "Начало",
    "book.to": "Окончание",

    /* BOOKING ACTIONS */
    "book.cancelTitle": "Отменить бронь",
    "book.cancelConfirm": "Отменить бронь?",
    "book.cancelButton": "Отменить бронь",
    "book.cancelledSuccess": "Бронь отменена",
    "book.cancelArrivedNote": "игрок уже заходил в игру",
    "book.cancelLiveNote": "бронь идёт прямо сейчас",

    /* BOOKING WINDOW MODAL */
    "book.windowTitleAction": "Изменить время",
    "book.windowTitle": "Время брони",
    "book.windowSubtitle": "Продлить или сократить — игра и игрок остаются те же",
    "book.windowButton": "Сохранить время",
    "book.windowSuccess": "Время брони изменено",
    "book.was": "Было",
    "book.becomes": "Станет",

    /* BOOKING FILTER MODAL */
    "book.filterTitle": "Фильтр броней",
    "book.filterSubtitle": "Период, статус, операторы и игры",
    "book.filterHint": "Пустой выбор означает все VIP игры доступа.",
    "book.allStatuses": "Все статусы",
    "book.reset": "Сбросить",
    "book.period.title": "Период",
    "book.period.today": "Сегодня",
    "book.period.tomorrow": "Завтра",
    "book.period.yesterday": "Вчера",
    "book.period.next7days": "Ближайшие 7 дней",
    "book.period.last7days": "Последние 7 дней",
    "book.period.thisMonth": "Этот месяц",
    "book.period.prevMonth": "Прошлый месяц",
    "book.period.all": "За все время",

    /* BOOKING ERRORS */
    "book.error.selectOperator": "Выберите оператора",
    "book.error.emptyPlayer": "Укажите ID игрока",
    "book.error.selectGame": "Выберите VIP игру",
    "book.error.selectWindow": "Укажите время брони",
    "book.error.wrongWindow": "Окончание должно быть позже начала",
    "book.error.sameWindow": "Время брони не изменилось",

}

export default ru
